import script from "./generate-temporary-password.vue?vue&type=script&setup=true&lang=js"
export * from "./generate-temporary-password.vue?vue&type=script&setup=true&lang=js"

import "./generate-temporary-password.vue?vue&type=style&index=0&id=0d29acea&lang=css"

const __exports__ = script;

export default __exports__